import { useMutation, useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';

import { get } from 'lodash';

import axiosClient from '@lib/utils/axiosClient';

import { showMessage } from 'actions';

import { keys } from '../keys';

const postGeneratePreview = async (website: string) => {
  const { data } = await axiosClient.post('/fileUploads/lumabot/preview', { website });

  return data as Response;
};

export default function useGenerateLumaBotPreview() {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  const { mutate } = useMutation(postGeneratePreview, {
    onSuccess: (response: any) => queryClient.invalidateQueries([keys.$entityId(get(response, '_id'))]),
    onError: (error: Error) => {
      dispatch(showMessage(get(error, 'message'), 'error'));
    },
  });

  return mutate;
}
